import { http, queryString } from 'utils'
import { findIndex, find, set, filter } from 'lodash'

// Planned load mutation imports.
import { SET_LOADS, ADD_LOAD, REMOVE_LOAD, ADD_EMPTY_LOAD, SET_LOAD_ATTRIBUTE, RESET_LOADS } from 'vx/mutations'

import { initialLoadState } from 'vx/modules/load'

// Load state.
const state = {
  plannedLoads: [
    initialLoadState()
  ]
}

// Load state getters.
const getters = {
  /**
   * Get the next planned load order.
   */
  nextPlannedLoadOrder: (state, getters) => getters.plannedLoadsWithoutEmpty.length + 1,

  /**
   * All planned loads excluding the empty planned load.
   */
  plannedLoadsWithoutEmpty: state => filter(state.plannedLoads, plannedLoad => plannedLoad.id !== null),

  /**
   * The empty planned load.
   */
  emptyPlannedLoad: state => find(state.plannedLoads, plannedLoad => plannedLoad.id === null)
}

// Load actions.
const actions = {
  /**
  * Get planned loads for a given job.
  */
  getPlannedLoads ({ commit, rootState: { job: jobState }, getters }, payload) {
    commit(RESET_LOADS)

    const job = jobState.job.id

    return http.get(`jobs/${job}/planned-loads?${queryString(payload)}`).then(response => {
      commit(SET_LOADS, response.data)
      commit(ADD_EMPTY_LOAD, { order: getters.nextPlannedLoadOrder })

      return response
    })
  },

  /**
   * Add a new planned load to the plan. Resets the empty job state.
   */
  addNewPlannedLoad ({ commit, getters }, load) {
    commit(ADD_LOAD, load)
    commit(ADD_EMPTY_LOAD, { order: getters.nextPlannedLoadOrder })
  }
}

// Load state mutations.
const mutations = {
  /**
  * Set the loads.
  */
  [SET_LOADS] (state, plannedLoads) {
    state.plannedLoads = plannedLoads
  },

  /**
   * Add a planned load or replace an existing.
   */
  [ADD_LOAD] (state, load) {
    let existingLoad = findIndex(state.plannedLoads, existing => existing.id === load.id)

    if (existingLoad === -1) {
      state.plannedLoads.push(load)
    } else {
      state.plannedLoads.splice(existingLoad, 1, load)
    }
  },

  /**
   * Remove a planned load from the job.
   */
  [REMOVE_LOAD] (state, load) {
    state.plannedLoads.splice(findIndex(state.plannedLoads, existing => existing.id === load.id), 1)
  },

  /**
   * Add an empty load to the planned loads.
   */
  [ADD_EMPTY_LOAD] (state, { order }) {
    const emptyPlannedLoad = initialLoadState({
      order: order
    })

    let existingEmptyLoad = findIndex(state.plannedLoads, plannedLoad => plannedLoad.id === null)

    if (existingEmptyLoad === -1) {
      state.plannedLoads.push(emptyPlannedLoad)
    } else {
      state.plannedLoads.splice(existingEmptyLoad, 1, emptyPlannedLoad)
    }
  },

  /**
   * Set a load attribute.
   */
  [SET_LOAD_ATTRIBUTE] (state, { id, attribute, value }) {
    let loadIndex = findIndex(state.plannedLoads, existing => existing.id === id)

    set(state.plannedLoads[loadIndex], attribute, value)
  },

  /**
   * Reset planned loads.
   */
  [RESET_LOADS] (state) {
    state.plannedLoads = [initialLoadState()]
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/job/planned-loads.js